<!--
	@name app-awards
	@description Awards page
	@date 2020/05/20
	@license no license
	@copywrite Answers In Retirement Limited
-->

<template>
	<div :component="$options.name">
		<div class="py-15 hero">
			<v-container fill-height>
				<v-row>
					<v-col class="align-content-center justify-start">
						<div :style="{ 'line-height': $vuetify.breakpoint.lgAndUp ? '4rem' : 'auto' }" class="text-h4 text-md-h3 text-lg-h2 text-md-h3 text-lg-h2 text-sm-left white--text font-weight-bold">
							Later Life Lending <br />
							Awards 2024
						</div>
					</v-col>
					<v-col class="align-content-center" style="justify-items: end;">
						<v-img style="width:12rem" :src="'logo/brand/later-life-lending-awards-icon.png' | urlize" />
					</v-col>
				</v-row>
			</v-container>
		</div>

		<v-container class="section0 py-8" :class="{ 'py-15': $vuetify.breakpoint.mdAndUp }">
			<div class="text-center d-flex align-center flex-column px-md-10">
				<p class="text-h5 text-md-h4 text-lg-h3 font-weight-bold mb-6" :style="{ 'line-height': $vuetify.breakpoint.lgAndUp ? '3.75rem' : 'auto' }">
					About the awards
				</p>
				<p class="text-body-1 bypass--line-height--override text-md-h6 font-weight-regular mb-4">
					As the market leading distribution channel and platform for later life lending professionals, Air was thrilled to announce the third Later Life Lending Awards which took place at the iconic Allianz Stadium - Twickenham.
				</p>
				<p class="text-body-1 bypass--line-height--override text-md-h6 font-weight-regular mb-0">
					This prestigious event honoured and celebrated the most exceptional advisers, lenders, networks, and stakeholders from across the industry. Bringing together a diverse array of later life propositions, the awards highlighted excellence across the sector, reflecting the evolving landscape and the industry's forward-thinking definition of later life lending.
				</p>
			</div>
		</v-container>

		<v-container>
			<v-divider />
		</v-container>

		<v-container class="py-8" :class="{ 'py-15': $vuetify.breakpoint.mdAndUp }">
			<div class="text-center text-sm-left d-flex align-center flex-column mx-auto mb-10">
				<p class="text-h6 text-md-h5 text-lg-h4 font-weight-bold mb-0">
					2024 Categories
				</p>
			</div>

			<v-row no-gutters class="justify-center mt-4" :class="{ 'mt-6': $vuetify.breakpoint.mdAndUp }">
				<v-col v-for="(item, i) in awards" :key="i" cols="12" md="4" class="d-flex flex-column">
					<v-card
						class="ma-6 pa-0 text-center flex d-flex flex-column rounded"
						color="white"
						elevation="2"
						hover
						style="overflow: hidden; background-image:linear-gradient(315deg, rgba(27, 120, 216, 0.15) 0%, rgba(255, 255, 255, 0) 75%)"
						@click="openDialog(i)"
					>
						<div class="d-flex flex-column h-100">
							<v-card-text class="flex pa-0">
								<div
									style="height: 250px; background-size: cover; background-position: 50% 50%;"
									:style="`background-image: url('${VUE_APP_S3_AIR_ASSETS_URL}/${item.image}');`"
								>
									<div class="d-flex flex-column justify-space-between h-100 pa-4 image--hover" style="background-image: linear-gradient(135deg, rgba(0,0,0,0.65) 45%, rgba(53,2,83,0.8) 90%);">
										<div class="text-h6 font-weight-bold white--text justify-center pt-4 px-6" style="text-shadow: 1px 1px 2px black;">
											{{ item.category }}
										</div>
										<div v-if="item.presentedBy" class="white--text justify-center mt-4 px-6">
											<p class="text-body-2 font-weight-regular mb-0" style="text-shadow: 1px 1px 2px black;">
												Presented by
											</p>
											<p class="text-body-2 font-weight-medium mb-0" style="text-shadow: 1px 1px 2px black;">
												{{ item.presentedBy }}
											</p>
										</div>
									</div>
								</div>

								<v-img class="d-none" :src="item.image | urlize" width="100%" height="250" cover />

								<div
									class="text-h6 white--text font-weight-regular justify-center py-4 px-6 background--wavy d-none"
									:class="{ 'background--wavy--alt':i%3==1, 'background--wavy--alt--2':i%3==2 }"
								>
									{{ item.category }}
								</div>
								<div
									class="d-none text-h6 font-weight-bold justify-center pt-4 px-6"
									style="color:#350253;"
								>
									{{ item.category }}
								</div>
								<div v-if="item.presentedBy" class="d-none justify-center mt-4 px-6">
									<p class="text-body-2 font-weight-regular grey--text text--darken-2 mb-0">
										Presented by
									</p>
									<p class="text-body-2 font-weight-medium mb-0" style="color:#350253;">
										{{ item.presentedBy }}
									</p>
								</div>
								<div class="justify-center mt-8 mb-8 px-6">
									<p class="text-h6 font-weight-regular grey--text text--darken-2 mb-0">
										Winner
									</p>
									<p class="text-h4 font-weight-medium mb-0" style="color:#350253;">
										{{ item.winner }}
									</p>
								</div>
								<div v-if="item.presentedBy" class="justify-center mt-6 px-6">
									<p class="text-body-2 font-weight-regular grey--text text--darken-2 mb-0">
										Commended
									</p>
									<p class="text-body-2 font-weight-medium mb-0" style="color:#350253;">
										{{ item.commended }}
									</p>
								</div>
							</v-card-text>

							<v-card-actions class="justify-center align-content-end justify-end mt-8 px-6 pb-4">
								<v-btn block dark color="#1b78d8">
									See Description
								</v-btn>
							</v-card-actions>
						</div>

						<v-dialog v-model="dialog[i]" max-width="500px" transition="dialog-transition">
							<v-card class="pa-2">
								<v-card-text>
									<v-btn icon style="position: absolute; right: 18px; top: 18px" @click="closeDialog(i)">
										<v-icon>mdi-close</v-icon>
									</v-btn>
									<div class="text-h6 justify-center secondary--text" style="line-height: 1">
										{{ item.category }}
									</div>
									<div class="text-body-2 mt-4">
										{{ item.description }}
									</div>
								</v-card-text>
							</v-card>
						</v-dialog>
					</v-card>
				</v-col>
			</v-row>
		</v-container>

		<!-- 2023 -->
		<div class="background--alt">
			<v-container class="fill-height text-center d-flex flex-column align-center py-16">
				<v-col class="d-flex flex-column align-center white--text">
					<p class="text-center text-h6 text-md-h5 text-lg-h4 font-weight-bold mb-6">
						The 2023 Winners
					</p>
					<p class="text-center text-body-1 bypass--line-height--override text-md-h6 font-weight-regular" style="max-width: 950px">
						Congratulations from Air to our 2023 winners. It's an honour to recognise you and your firms for your contribution to the later life lending market.
					</p>
					<img class="mt-6" :src="'events/AirAwards2023-192-ALL-WINNERS-1-scaled-e1701948365886.jpg' | urlize" style="max-width: 861px" />
					<v-btn to="/awards-2023" large class="mt-8" dark color="#1b78d8">
						View winners
					</v-btn>
				</v-col>
			</v-container>
		</div>

		<!-- 2022 -->
		<div class="background--alt">
			<v-container class="fill-height text-center d-flex flex-column align-center py-16">
				<v-col class="d-flex flex-column align-center white--text">
					<p class="text-center text-h6 text-md-h5 text-lg-h4 font-weight-bold mb-6">
						The 2022 Winners
					</p>
					<p class="text-center text-body-1 bypass--line-height--override text-md-h6 font-weight-regular" style="max-width: 950px">
						A huge congratulations to our winners from the 2022 Air Awards night, and thanks for all the continued work you've done this past year.
					</p>
					<img class="mt-6" :src="'events/2022-Awards-winners.png' | urlize" style="max-width: 861px" />
					<v-btn to="/awards-2022" large class="mt-8" dark color="#1b78d8">
						View winners
					</v-btn>
				</v-col>
			</v-container>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'app-awards',

		components: {},

		data() {
			return {
                VUE_APP_S3_AIR_ASSETS_URL: process.env.VUE_APP_S3_AIR_ASSETS_URL,
				dialog: [],
                dates: [
                    {
                        id: 1,
                        title: 'Nominations Open',
                        date: '18th October - 5th November'
                    },
                    {
                        id: 2,
                        title: 'Longlist Announced',
                        date: '6th November'
                    },
                    {
                        id: 3,
                        title: 'Voting Period',
                        date: '6th November – 18th November'
                    },
                    {
                        id: 4,
                        title: 'Shortlist Announced',
                        date: '19th November'
                    },
                    {
                        id: 5,
                        title: 'Shortlist Submissions',
                        date: '19th November - 6th December'
                    },
                    {
                        id: 6,
                        title: 'Judging Period',
                        date: '9th December - 12th December'
                    },
                    {
                        id: 7,
                        title: 'Finalists Informed',
                        date: '20th December'
                    },
                    {
                        id: 8,
                        title: 'Awards Evening',
                        date: '16th January'
                    }
                ],
				awards: [
					{
						"category": "Best adviser support specialist at a lender",
						"presentedBy": "Paul Glynn (Air)",
						"winner": "Kaitlyn Buxton",
						"commended": "Sarah Yetton",
						"image": "manager_documents/a923d44d-0cca-4591-8c0a-d29edb4e3765.jpg",
						"description": "This category recognises individuals working within a lender for providing exceptional personalised assistance to financial advisers, enabling them to offer top-tier services to their clients, enhancing efficiency, compliance, and overall client satisfaction."
					},
					{
						"category": "Outstanding legal services in later life lending",
						"presentedBy": "Sanjay Gadhia (Standard Life Home Finance)",
						"winner": "Equilaw",
						"commended": "Moss & Coleman",
						"image": "manager_documents/3af4e340-17e5-47b1-8759-ad48e786ab7a.jpg",
						"description": "Independent legal advice is essential in the later life lending sector. This award honours the conveyancers who deliver exceptional, personalised legal guidance, tailored to meet the unique needs of each client. It recognises the firms that have set themselves apart by providing high-quality, client-focused support in an increasingly complex landscape."
					},
					{
						"category": "Outstanding support firm for later life lending",
						"presentedBy": "Harry Stratford (Poynton Law)",
						"winner": "Advice Guru",
						"commended": "The Right Mortgage and Protection Network",
						"image": "manager_documents/347b6637-2529-4e18-a54e-60a7d89d3054.jpg",
						"description": "In a rapidly evolving and complex market, offering advisers the right support to stay ahead has been crucial. From the latest product innovations and advancements in technology to navigating regulatory changes, firms have had to continually adapt and enhance their support. This award recognizes the company that has excelled in providing advisers with the tools and resources needed to thrive in the later life lending sector. Who has truly set the standard?"
					},
					{
						"category": "Best Large Advisory Firm (+5)",
						"presentedBy": "Kay Westgarth (Aviva)",
						"winner": "The Later Life Lending Network",
						"commended": "The Later Life Club",
						"image": "manager_documents/0086a4ef-1a72-446b-bae2-3c27594323db.jpg",
						"description": "This category is designed to recognise the stand-out performance of firms that put customer outcomes at the heart of their propositions, going above and beyond to improve every touchpoint."
					},
					{
						"category": "Best Small Advisory Firm (1-4)",
						"presentedBy": "Fran Green (more2life)",
						"winner": "Knight Frank Finance",
						"commended": "StepChange Financial Solutions",
						"image": "manager_documents/b63d2bca-47ed-40cd-85d1-260bcdb9cd22.jpg",
						"description": "This category recognises the effort of smaller equity release advisory firms in their own right, who make a big impact across the later life lending industry."
					},
					{
						"category": "Best Later Life Innovation",
						"presentedBy": "Emma Ellis (Air)",
						"winner": "Equilaw - Novex",
						"commended": "more2life",
						"image": "manager_documents/d7171d52-95c1-4a12-b331-2b69b680af9f.jpg",
						"description": "This category recognises firms striving to support advisers by quickly evolving and adapting to the changing market condition. Whether it's a product, a new feature, an enhanced service or an online tool, which firm has delivered the greatest innovation to the market this year?"
					},
					{
						"category": "Best Later Life Lending Provider",
						"presentedBy": "Matthew Taylor (Equilaw)",
						"winner": "more2life",
						"commended": "Standard Life Home Finance",
						"image": "manager_documents/545fe00f-d0db-40ad-9f55-9c8bcd8bdcdb.jpg",
						"description": "This award recognises providers who have showcased and championed later life lending excellence. These have been at the forefront of supporting advisers with their product and service offering."
					},
					{
						"category": "Network of the year",
						"presentedBy": "Jonathon McCaffrey (JUST)",
						"winner": "HL Partnership",
						"commended": "The Right Mortgage Network",
						"image": "manager_documents/25f0575a-55e4-49aa-a8e0-39addec8e387.jpg",
						"description": "This award goes to the Network that has made the biggest impact in later life lending this year, through supporting their members with education, resources and tools to enable them to offer their clients more options to meet their needs."
					},
					{
						"category": "BDM of the Year",
						"presentedBy": "Nick Flynn (Canada Life)",
						"winner": "Dan Borrill",
						"commended": "Rachel Flanagan",
						"image": "manager_documents/e36f23a8-1632-48b0-bb9d-880f5cfaaedb.jpg",
						"description": "This category recognises a Business Development Manager who has demonstrated their skill, market expertise and knowledge to support advisers to navigate the changes impacting the industry and done this with passion and a positive attitude."
					},
					{
						"category": "Later Life Adviser of the Year",
						"presentedBy": "Nick Birdseye (Legal & General)",
						"winner": "Leigh Bass",
						"commended": "John Harris",
						"image": "manager_documents/d140344e-de44-4089-8413-aabf75ebbb72.jpg",
						"description": "This award recognises the individual who is the leading light when it comes to advice delivery, customer service and continuing professional development - a true local hero of their community. It is one of our most coveted award categories."
					},
					{
						"category": "New adviser of the Year",
						"presentedBy": "Colin Bell (Perenna)",
						"winner": "Mike Jones",
						"commended": "Kris Buda",
						"image": "manager_documents/75c861a5-6437-4962-a9c7-2b04d2c41497.jpg",
						"description": "This award celebrates the outstanding achievements of advisers in their first year within the later life lending industry. These individuals have not only navigated significant challenges but have also demonstrated exceptional resilience, professionalism, and a commitment to excellence. Who has truly made their mark as a rising star in the industry?"
					},
					{
						"category": "Underwriter of the Year",
						"presentedBy": "Darren Deacon (Family Building Society)",
						"winner": "Imran Iqbal",
						"commended": "Brittany Dean",
						"image": "manager_documents/21834cf1-b46d-4e17-8e52-9d1fcadf3ae4.jpg",
						"description": "This award will recognise the best of the best when it comes to lending criteria expertise and support, these underwriters are the unsung experts of our industry and key gatekeepers to lending success."
					},
					{
						"category": "Best customer support specialist at an advisory firm",
						"presentedBy": "Inken Franklin (Royal London Equity Release)",
						"winner": "Joe Brennan",
						"commended": "Tom Baxter",
						"image": "manager_documents/f0fb9b6f-6b0e-46bc-9807-b9d1a17b18da.jpg",
						"description": "This category recognises individuals within an advisory firm who demonstrate exceptional dedication to providing personalised, efficient, and professional support to clients. Their efforts enhance client experience, streamline operations, and contribute to the overall success of the firm."
					}
				]
			};
		},

		computed: {},

		created() {},

		methods: {
			openDialog(i) {
				this.$set(this.dialog, i, true);
			},
			closeDialog(i) {
				this.$set(this.dialog, i, false);
			}
		}
	};
</script>

<style lang="scss" scoped>
	.hero {
        position: relative;
        overflow: hidden;
        z-index: 1;
        height: 400px;
        border-bottom: 20px solid #1b78d8;
		background-blend-mode: multiply;
		background-color: rgba(27,120,216,0.4);
        background-position: 50% 50%;
        background-repeat: no-repeat;
        background-size: cover;
		background-image: url($VUE_APP_S3_AIR_ASSETS_URL + '/manager_documents/d0bb7b46-b858-45ac-8e11-15f9c7883eb7.png');
    }

	#overlay {
		position: absolute;
		top: 0;
		left: 0;
		height: 100%;
		width: 100%;
		background-color: transparent;
		background-image: linear-gradient(340deg, #6464645c 45%, #1eb0e1 100%);
		opacity: 1;
		mix-blend-mode: multiply;
		transition: background 0.3s, border-radius 0.3s, opacity 0.3s;
	}

	.background--wavy {
		background-color: #3f3195;
		background-position: 50% 50%;
		background-size: cover;
		background-image: url($VUE_APP_S3_AIR_ASSETS_URL+'/manager_documents/7aed7769-4814-4c94-bc82-6db969ef5dda.png');

		&--alt {
			background-image: url($VUE_APP_S3_AIR_ASSETS_URL+'/manager_documents/4f349c68-854f-4f1d-ad40-afe568de8fed.png');
		}

		&--alt--2 {
			background-image: url($VUE_APP_S3_AIR_ASSETS_URL+'/manager_documents/73959188-6cd2-46b4-8091-5241e24ab0a7.png');
		}

		svg {
			display: block;
		}
	}

	.background--alt {
        border-bottom: 20px solid #196AFF;
        background-position: 50% 50%;
        background-size: cover;
        background-attachment: fixed;
        background-image: url($VUE_APP_S3_AIR_ASSETS_URL+'/manager_documents/d0bb7b46-b858-45ac-8e11-15f9c7883eb7.png');
    }

	.image--hover {
		transition-duration: 500ms;

		&:hover {
			opacity: 0;
		}
	}
</style>
